module.exports = __webpack_public_path__ + "img/minbannera.b33415fa.png";